import { CompanyAuthenticationTabBaseDataProvider } from './CompanyAuthenticationTabBaseDataProvider';
import { MyCompanyAuthenticationData } from '../../../types/company-data';

export class CompanyAuthenticationTabGzDataProvider extends CompanyAuthenticationTabBaseDataProvider {
  async getMyCompanyAuthenticationData(companyId: string): Promise<MyCompanyAuthenticationData> {
    const record = await this.dependencies.api.clients.Company.GetAuthenticationSettings(companyId).toPromise();
    return record.data;
  }
}
